@if (!environment.preview || (!!currentCountry && !!currentLanguage)) {
    <sew-ws-header
        #header
        oscHeaderEvents
        baseUrl="{{ baseURL }}"
        caasBaseUrl="{{ caasBaseUrl }}"
        [apiBaseUrl]="apiBaseUrl"
        [useTracking]="true"
        [useCMP]="useCMP"
        [isPreview]="environment.preview"
        [attr.selectedLanguage]="environment.preview ? currentLanguage : null"
        [attr.countryCode]="environment.preview ? currentCountry : null"
        breadcrumbId="international_regulations"
        [environment]="stage"
        [clientId]="authConfig.clientId"
        [policy]="authConfig.policy"
        [scopes]="authConfig.scopes"
        [redirectUri]="postLoginUrl"
        [postLogoutRedirectUri]="postLogoutUrl"
    ></sew-ws-header>
}

<reg-landing-page [currentPage]="currentPage"></reg-landing-page>
@if (contactButtonUrl.length > 0) {
    <sew-ws-floating-buttons-contact-options [contactApiUrl]="contactButtonUrl">
    </sew-ws-floating-buttons-contact-options>
}
@if (language.length > 0 && countryCode.length > 0) {
    <sew-ws-footer-api
        [caasBaseUrl]="caasBaseUrl"
        [countryCode]="countryCode"
        [language]="language.toUpperCase()"
        [displayNewestBlogPost]="displayFooterBlogPost"
    >
        @for (link of footerLinks; track link) {
            <a slot="additional-legal-links" [href]="link.url" [target]="link.target"> {{ link.text }}</a>
        }
    </sew-ws-footer-api>
}
